export default __webpack_public_path__ + "static/media/tinyapp.d41dc7cc.jpg";